export const HERO_CONSTANTS = {
  button: {
    label: "Unlock the power of cloud-native solutions now",
    link: "#contact-us",
  },
  content:
    "Leverage Virtuozzo IaaS and PaaS to deploy and manage cloud infrastructure and applications with ease. Scale effortlessly while ensuring high availability.",
  title: "Cloud-Native Infrastructure & Application Platform",
};
